import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import React, { Component, createRef } from 'react';
import { FormattedMessage, injectIntl } from "react-intl";
import GlobalHelper from "../../../../common/GlobalHelper.jsx";
import Icon from "../../../../common/icon/icon.component.jsx";
import { INTEGRATION_KEY } from '../../../../state/integration/Constants';
import { extractClientIdAndSlug, getSchedulingPageIntegrationKey } from "../../../../utils/scheduling/";
import SectionWrapper from "../../sectionwrapper.component.jsx";
import "./styles/scheduler.scss";
const queryString = require('query-string')

class SchedulerContentSection extends Component {

    constructor(props, context) {
        super(props, context)
        let searchQuerySplit = (window.location.href).split('?')
        let search = `?${searchQuerySplit[1]}`
        let searchParams = queryString.parse(search)

        this.state = {
            modalId: this.props.modalId || 'scheduling-page',
            className: this.props.className || '',
            section: this.props.section || null,
            isDummy: this.props.isDummy === true,
            isPdf: this.props.isPdf === true,
            variables: this.props.variables || null,
            editable: this.props.editable || false,
            edition: this.props.edition || false,
            included: this.props.included || false,
            onEdit: this.props.onEdit || function () { },
            id: this.props.id || '',
            loading: false,
            schedulingPage: this.props.variables ? this.props.variables.schedulingPage : null,
            searchParams: searchParams,
            contact: null,
            identifier: '',
            projectId: '',
            proposalLink: '',
            nylasScheduling: '',
            slug: '',
            sessionId: null,
        }

        this.nylasSchedulingRef = createRef()
        this.getEndPoint = this.getEndPoint.bind(this)
    }

    componentDidMount() {
        let endPoint = this.getEndPoint()
        if (endPoint) {
            AppContext.getApiClient().get(endPoint).then(doc => {
                this.setState({
                    contact: doc.attributes.contact,
                    projectId: doc.attributes.projectId,
                    identifier: doc.attributes.identifier,
                }, () => {
                    AppContext.getApiClient().get('/proposals/' + doc.attributes.proposalHash).then(res => {
                        this.setState({
                            proposalLink: res.attributes.publicLink,
                        })
                    })
                })
            })
        }

        this.updateNylasSchedulingAttributes()
    }

    getEndPoint() {
        let invoiceId = this.state.searchParams["invoiceId"]
        let orderId = this.state.searchParams["orderId"]
        let quoteId = this.state.searchParams["quoteId"]

        if (invoiceId) {
            return "/invoices/" + invoiceId
        }
        if (orderId) {
            return "/orders/" + orderId
        }
        if (quoteId) {
            return "/quotes/" + quoteId
        }
        return null
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.schedulingPage !== this.state.schedulingPage ||
            prevState.sessionId !== this.state.sessionId) {
            this.updateNylasSchedulingAttributes();
        }
    }

    updateNylasSchedulingAttributes() {
        if (!this.nylasSchedulingRef.current) {
            return
        }

        const { schedulingPage, sessionId } = this.state

        if (schedulingPage) {
            const data = extractClientIdAndSlug(schedulingPage.attributes.urlLink)
                
            if (data) {
                this.nylasSchedulingRef.current.setAttribute("slug", data.slug);
                this.nylasSchedulingRef.current.setAttribute("client-id", data.clientId);
            }
        }
        if (sessionId) {
            this.nylasSchedulingRef.current.setAttribute("session-id", sessionId);
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            section: nextProps.section || null,
            variables: nextProps.variables || null,
            isDummy: nextProps.isDummy === true,
            id: nextProps.id || '',
        })
    }

    render() {
        if (!this.state.section) {
            return <div />
        }
        if (this.state.schedulingPage && this.state.schedulingPage.attributes.status === 'inactive') {
            return <div />
        }

        const integrationKey = getSchedulingPageIntegrationKey(this.state.schedulingPage)

        let height = '600px'
        if (['xs', 'sm'].includes(GlobalHelper.getResponsiveBreakpoint())) {
            height = '750px'
        }
        let contactInfo = this.state.contact && this.state.contact.attributes ?
            (
                "?email=" + this.state.contact.attributes.email +
                "&name=" + this.state.contact.attributes.name +
                "&identifier=" + this.state.identifier +
                "&projectId=" + this.state.projectId +
                "&proposalLink=" + this.state.proposalLink
            ) : ""
        return (
            <SectionWrapper
                id={this.state.id}
                section={this.state.section}
                onEdit={this.state.onEdit}
                editable={this.state.editable}
                variables={this.state.variables}
                included={this.state.included}
            >
                {integrationKey == INTEGRATION_KEY.NYLAS && <div className={'col-12'}>
                    <div className={'row'}>
                        {this.state.schedulingPage ?
                            <iframe
                                style={{}}
                                src={this.state.schedulingPage.attributes.urlLink + contactInfo}
                                id={this.state.modalId + '_iframe'} width="100%" height={height} frameBorder="0" /> :
                            <FormattedMessage
                                id="scheduler.scheduling_url_not_found"
                                defaultMessage="Scheduling page url not found"
                            />
                        }
                    </div>
                </div>}
                {integrationKey == INTEGRATION_KEY.NYLASV3 &&
                    <div className="row pb-3">
                        <div className="d-flex justify-content-center flex-wrap scheduler-section-container mb-1">
                            <div className='w-100 d-flex mt-3 justify-content-center pb-2' style={{ height: "max-content"}}>
                                <h4 className="p-0" style={{ height: "max-content"}}>
                                    <Icon value={"calendar-day"} className={"mr-2"} />
                                    <FormattedMessage
                                        id="scheduler.schedule_a_meeting"
                                        defaultMessage="Schedule a meeting"
                                    />
                                </h4>
                            </div>
                            <div className='w-100 d-flex mt-3 justify-content-center'>
                                {this.state.schedulingPage 
                                    ? <nylas-scheduling ref={this.nylasSchedulingRef}></nylas-scheduling>
                                : <FormattedMessage
                                id="scheduler.scheduling_url_not_found"
                                defaultMessage="Scheduling page url not found"
                            />}
                            </div>
                        </div>
                    </div>}
            </SectionWrapper>
        );
    }
}

export default injectIntl(SchedulerContentSection)


// WEBPACK FOOTER //
// ./src/template/sections/content/scheduler/section.component.jsx